export type IconSize = 'sm' | 'md' | 'lg'

export function fromSize(size: any) {
  switch (size) {
    case 'sm':
      return '18px'
    case 'md':
      return '24px'
    case 'lg':
      return '32px'
    default:
      return size
  }
}
